import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import { computed } from "vue";
import { NavigationButtonState } from "@/ui/chrome/mainnavigation.service";


export default /*#__PURE__*/_defineComponent({
  __name: 'MainNavigationButtons',
  props: {
    state: null
  },
  setup(__props: any) {

const myAccountRoot = computed<INavigationViewObject | null>(() => store.getters["app/myAccountRoot"]);
const portalRoot = computed<INavigationViewObject | null>(() => store.getters["app/portalRoot"]);
const navigationButtonState = NavigationButtonState;



return { __sfc: true,myAccountRoot, portalRoot, navigationButtonState }
}

})